import { ClientDetailsWithRelations } from "@dune/vars";
import { ClientRoleEnum, ClientTypeEnum } from "@dune/types";

export const getClientTypeLabel = (type: string): string => {
	return type === ClientTypeEnum.SOCIETY ? "Société" : "Particulier";
};

export const getClientRoleLabel = (role: string): string => {
	switch (role) {
		case ClientRoleEnum.CLIENT:
			return "Client";
		case ClientRoleEnum.MOA:
			return "MOA";
		case ClientRoleEnum.CLIENT_MOA:
			return "Client / MOA";
		default:
			return "";
	}
};

export const getClientRef = (client: ClientDetailsWithRelations): string => {
	return `A-${client.id.toString().padStart(3, "0")}`;
};

export const getClientLastName = (client: ClientDetailsWithRelations): string => {
	if (client.clientType === "USER" && client.constructionSiteClientContacts.length > 0) {
		const contact = client.constructionSiteClientContacts[0]?.constructionSiteContact;
		if (contact?.lastname) return contact.lastname;
	}
	if (client.moaClientContact?.id === client.id && client.moaClientContact?.lastname) {
		return client.moaClientContact.lastname;
	}
	return "";
};

export const getClientFirstName = (client: ClientDetailsWithRelations): string => {
	if (client.clientType === "USER" && client.constructionSiteClientContacts.length > 0) {
		const contact = client.constructionSiteClientContacts[0]?.constructionSiteContact;
		if (contact?.firstname) return contact.firstname;
	}
	if (client.moaClientContact?.id === client.id && client.moaClientContact?.firstname) {
		return client.moaClientContact.firstname;
	}
	return "";
};

export const getClientCompanyName = (client: ClientDetailsWithRelations): string => {
	if (client.clientType === "SOCIETY" && client.clientSociety) {
		return client.clientSociety.denomination;
	}
	if (client.moaClientSociety?.id === client.id && client.moaClientSociety?.denomination) {
		return client.moaClientSociety.denomination;
	}
	return "";
};

export const getConstructionSiteRef = (client: ClientDetailsWithRelations): string => {
	if (client.ConstructionSite) {
		return `CH-${client.ConstructionSite.id.toString().padStart(4, "0")}`;
	}
	return "";
};

export const getBrokerName = (client: ClientDetailsWithRelations): string => {
	return client.ConstructionSite?.brokerSociety?.denomination || "";
};

export const getClientStatusLabel = (status: string): string => {
	switch (status) {
		case "NEW":
			return "Nouveau";
		case "IN_PROGRESS":
			return "En cours";
		case "CANCELLED":
			return "Annulé";
		case "VALIDATED":
			return "Validé";
		case "SUBMITTED":
			return "Soumis";
		case "TO_RECEIVE":
			return "À réceptionner";
		default:
			return "Inconnu";
	}
};

export const getClientStatusStyle = (status: string): string => {
	switch (status) {
		case "NEW":
			return "text-blue-badge-text bg-blue-badge-background border-blue-badge-border";
		case "IN_PROGRESS":
			return "text-green-badge-text bg-green-badge-background border-green-badge-border";
		case "CANCELLED":
			return "text-red-badge-text bg-red-badge-background border-red-badge-border";
		case "VALIDATED":
			return "text-green-badge-text bg-green-badge-background border-green-badge-border";
		case "SUBMITTED":
			return "text-orange-badge-text bg-orange-badge-background border-orange-badge-border";
		case "TO_RECEIVE":
			return "text-purple-badge-text bg-purple-badge-background border-purple-badge-border";
		default:
			return "text-gray-badge-text bg-gray-badge-background border-gray-badge-border";
	}
};

export const getClientStatus = (client: ClientDetailsWithRelations): string => {
	return client.ConstructionSite?.status || "";
};

export const getClientId = (client: ClientDetailsWithRelations): string => {
	return client.id.toString();
}; 
